import { Switch, type SwitchProps } from '@chakra-ui/react'
import { SizeType } from '@/types'
import React from 'react'


interface Props extends SwitchProps {
  size?: SizeType,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Switch ref={ref} { ...props } />
  )
})


export {
  Component as Switch,
  type Props as SwitchProps,
}